import { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue'

const testRoutes: RouteConfig = {
    path: '/setting',
    component: Layout,
    meta: {
        title: 'setting',
        icon: 'international',
        redirect: '/setting/system',
        // alwaysShow: true 
    },
    children: [
        {
            path: 'system',
            component: () => import('@/views/setting/system.vue'),
            meta: {
                title: 'setting',
                icon: 'setting',
                activeMenu: '/setting/system',
            }
        }
    ]

}

export default testRoutes